module.exports = __webpack_public_path__ + "static/media/Travel.ebb4229d.png";